import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import i18n from 'i18n';
import { ChannelGroupListDTO } from 'core/channelGroup/ChannelGroup';
import styles from './archiveReasonCell.module.scss';

/**
 * ECOPD-5701：列表的「停用理由」欄。兩個來源各自有值就各印一行、帶來源前綴。
 *
 * ⚠️ 判定用 truthy，**不要**寫 `=== null` —— 沒有理由時整個 key 不存在。
 * 「已停用但沒有理由」是合法狀態，渲染成空白，不得顯示錯誤或佔位符。
 *
 * ⚠️ 截斷靠 `.cell` 的 `max-width` 與 `.line` 的單行省略**兩者一起**，缺一不可。
 * 只給 `text-overflow: ellipsis` 不限寬沒有用：表格是 auto layout，欄寬會長到
 * 容納最長那一行，不換行就不會截斷。
 */
export const ArchiveReasonCell: React.FC<{
  channelGroup: ChannelGroupListDTO;
}> = ({ channelGroup }) => {
  const lines = [
    channelGroup.pmaxArchiveReason && {
      key: 'pmax',
      text: i18n.t('channelGroupList.labels.archiveReasonPmax', {
        reason: channelGroup.pmaxArchiveReason
      })
    },
    channelGroup.rmaxArchiveReason && {
      key: 'rmax',
      text: i18n.t('channelGroupList.labels.archiveReasonRmax', {
        reason: channelGroup.rmaxArchiveReason
      })
    }
  ].filter(Boolean) as { key: string; text: string }[];

  if (lines.length === 0) {
    return null;
  }

  // 理由上限 500 字，全文靠 tooltip 看，細讀點進詳情頁（詳情頁不截斷）。
  const fullText = lines.map((line) => line.text).join('\n');

  return (
    <OverlayTrigger
      placement='top'
      trigger={['hover', 'focus']}
      overlay={
        <Tooltip id={`channel-group-archive-reason-${channelGroup.id}`}>
          {fullText}
        </Tooltip>
      }
    >
      <div className={styles.cell}>
        {lines.map((line) => (
          <div key={line.key} className={styles.line}>
            {line.text}
          </div>
        ))}
      </div>
    </OverlayTrigger>
  );
};
